import { combineReducers } from 'redux';

import { alarmStateReducer } from '@sophocles/entities/AlarmState';
import { annualSolarReportReducer } from '@sophocles/entities/AnnualSolarReport';
import { authGroupReducer } from '@sophocles/entities/AuthGroup';
import { cameraReducer } from '@sophocles/entities/Camera';
import { cameraInterfaceControllerReducer } from '@sophocles/entities/CameraInterfaceController';
import { cameraScheduleReducer } from '@sophocles/entities/CameraSchedule';
import { cicStatusReducer } from '@sophocles/entities/CicStatus';
import { cicStatusHistoryReducer } from '@sophocles/entities/CicStatusHistory';
import { completedUnitCommandReducer } from '@sophocles/entities/CompletedUnitCommand';
import { customerReducer } from '@sophocles/entities/Customer';
import { customerOptionReducer } from '@sophocles/entities/CustomerOption';
import { customerPreferenceReducer } from '@sophocles/entities/CustomerPreference';
import { dailyInternationalPowerMeterReportReducer } from '@sophocles/entities/DailyInternationalPowerMeterReport';
import { dailySolarReportReducer } from '@sophocles/entities/DailySolarReport';
import { internationalMeterReadingReducer } from '@sophocles/entities/InternationalMeterReading';
import { intrusionSensorConfigurationReducer } from '@sophocles/entities/IntrusionSensorConfiguration';
import { issueCategoryReducer } from '@sophocles/entities/IssueCategory';
import { issueSubCategoryReducer } from '@sophocles/entities/IssueSubCategory';
import { koreSubscriptionReducer } from '@sophocles/entities/KoreSubscription/reducer';
import { monthlyInternationalPowerMeterReportReducer } from '@sophocles/entities/MonthlyInternationalPowerMeterReport';
import { monthlySolarReportReducer } from '@sophocles/entities/MonthlySolarReport';
import { pendingUnitCommandReducer } from '@sophocles/entities/PendingUnitCommand';
import { proofOfPerformance2PDCReportReducer } from '@sophocles/entities/ProofOfPerformance2PDCReport';
import { proofOfPerformanceReportReducer } from '@sophocles/entities/ProofOfPerformanceReport';
import { radioReducer } from '@sophocles/entities/Radio';
import { radioBillingReducer } from '@sophocles/entities/RadioBilling';
import { relayReducer } from '@sophocles/entities/Relay';
import { relayControllerFirmwareVersionReducer } from '@sophocles/entities/RelayControllerFirmwareVersion';
import { relayControllerStatusReducer } from '@sophocles/entities/RelayControllerStatus';
import { relayControllerStatusHistoryReducer } from '@sophocles/entities/RelayControllerStatusHistory';
import { relayLoadReducer } from '@sophocles/entities/RelayLoad';
import { relayLoadContractReducer } from '@sophocles/entities/RelayLoadContract';
import { relayScheduleReducer } from '@sophocles/entities/RelaySchedule';
import { rmaReducer } from '@sophocles/entities/Rma';
import { rmaFeeReducer } from '@sophocles/entities/RmaFee';
import { siteReducer } from '@sophocles/entities/Site';
import { siteAlarmOptionReducer } from '@sophocles/entities/SiteAlarmOption';
import { siteConfigurationReducer } from '@sophocles/entities/SiteConfiguration';
import { siteGroupReducer } from '@sophocles/entities/SiteGroup';
import { siteGroupWeatherConfigurationReducer } from '@sophocles/entities/SiteGroupWeatherConfiguration';
import { siteMaintenanceLogReducer } from '@sophocles/entities/SiteMaintenanceLog';
import { siteWeatherConfigurationReducer } from '@sophocles/entities/SiteWeatherConfiguration';
import { smartlinkModelReducer } from '@sophocles/entities/SmartlinkModel';
import { smartlinkParameterReducer } from '@sophocles/entities/SmartlinkParameter';
import { smartlinkUnitReducer } from '@sophocles/entities/SmartlinkUnit';
import { solarSiteOptionReducer } from '@sophocles/entities/SolarSiteOption';
import { testResultReducer } from '@sophocles/entities/TestResult';
import { thirdPartyCustomerRelationshipReducer } from '@sophocles/entities/ThirdPartyCustomerRelationship';
import { userReducer } from '@sophocles/entities/User';
import { userOptionReducer } from '@sophocles/entities/UserOption';
import { warrantyFeeReducer } from '@sophocles/entities/WarrantyFee';
import { warrantyStatusReducer } from '@sophocles/entities/WarrantyStatus';
import { weeklyInternationalPowerMeterReportReducer } from '@sophocles/entities/WeeklyInternationalPowerMeterReport';
import { weeklySolarReportReducer } from '@sophocles/entities/WeeklySolarReport';

const reducers = combineReducers({
  alarmStates: alarmStateReducer,
  annualSolarReports: annualSolarReportReducer,
  authGroups: authGroupReducer,
  cameras: cameraReducer,
  cameraInterfaceControllers: cameraInterfaceControllerReducer,
  cameraSchedules: cameraScheduleReducer,
  cicStatuses: cicStatusReducer,
  cicStatusHistories: cicStatusHistoryReducer,
  completedUnitCommands: completedUnitCommandReducer,
  customers: customerReducer,
  customerOptions: customerOptionReducer,
  customerPreferences: customerPreferenceReducer,
  dailyInternationalPowerMeterReports: dailyInternationalPowerMeterReportReducer,
  dailySolarReports: dailySolarReportReducer,
  internationalMeterReadings: internationalMeterReadingReducer,
  intrusionSensorConfigurations: intrusionSensorConfigurationReducer,
  issueCategories: issueCategoryReducer,
  issueSubCategories: issueSubCategoryReducer,
  koreSubscriptions: koreSubscriptionReducer,
  monthlyInternationalPowerMeterReports: monthlyInternationalPowerMeterReportReducer,
  monthlySolarReports: monthlySolarReportReducer,
  pendingUnitCommands: pendingUnitCommandReducer,
  proofOfPerformanceReports: proofOfPerformanceReportReducer,
  proofOfPerformance2PDCReports: proofOfPerformance2PDCReportReducer,
  radios: radioReducer,
  radioBillings: radioBillingReducer,
  relays: relayReducer,
  relayControllerFirmwareVersions: relayControllerFirmwareVersionReducer,
  relayControllerStatuses: relayControllerStatusReducer,
  relayControllerStatusHistories: relayControllerStatusHistoryReducer,
  relayLoads: relayLoadReducer,
  relayLoadContracts: relayLoadContractReducer,
  relaySchedules: relayScheduleReducer,
  rmas: rmaReducer,
  rmaFees: rmaFeeReducer,
  sites: siteReducer,
  siteAlarmOptions: siteAlarmOptionReducer,
  siteConfigurations: siteConfigurationReducer,
  siteGroups: siteGroupReducer,
  siteGroupWeatherConfigurations: siteGroupWeatherConfigurationReducer,
  siteWeatherConfigurations: siteWeatherConfigurationReducer,
  siteMaintenanceLogs: siteMaintenanceLogReducer,
  smartlinkUnits: smartlinkUnitReducer,
  smartlinkParameters: smartlinkParameterReducer,
  smartlinkModels: smartlinkModelReducer,
  solarSiteOptions: solarSiteOptionReducer,
  testResults: testResultReducer,
  thirdPartyCustomerRelationships: thirdPartyCustomerRelationshipReducer,
  users: userReducer,
  userOptions: userOptionReducer,
  warrantyFees: warrantyFeeReducer,
  warrantyStatuses: warrantyStatusReducer,
  weeklyInternationalPowerMeterReports: weeklyInternationalPowerMeterReportReducer,
  weeklySolarReports: weeklySolarReportReducer,
});

export default reducers;
